export const POST_GET = 'POST_GET';
export const POST_LOADED = 'POST_LOADED';
export const POST_SET = 'POST_SET';
